import moment from 'moment'

import { ActivityInfo } from 'app/models/activityContainerModel'
import { PlaceModel } from 'app/models/placeModel'
import { PlaceEntryType } from 'app/constants/placeEntryType'
import { CardInsertModel } from 'app/models/cardInsertModel'
import { CardActivityType } from 'app/constants/cardActivityType'
import { ActivityModel } from 'app/models'
import { OutOfScopeModel } from 'app/models/outOfScopeModel'
import { NoteModel } from 'app/models/noteModel'
import { getDayType } from 'app/services/calendar/dayTypeResolver'
import { ExistingDelegationModel } from 'app/models/existingDelegationModel'
import { EventModel } from 'app/models/newDelegation/eventModel'
import { getEventType } from 'app/services/delegation/tripEventTypeResolver'
import { getVehicleType } from 'app/services/delegation/vehicleTypeResolver'
import { getTmsRouteType } from 'app/services/tms/tmsRouteTypeResolver'

// Czyste mappery odpowiedzi API dla aktywnosci. Mieszkaly w activityReducer.ts
// razem ze slice'em reduxa, ktorego nikt juz nie czytal - slice zniknal, mappery
// sa nadal uzywane przez serwisy w src/modules.

export const mapActivity = (data: any): ActivityModel => {
  return {
    startTime: moment.utc(data.startTime).local(),
    endTime: data.endTime ? moment.utc(data.endTime).local() : null,
    driver: data.driver,
    coDriver: data.coDriver,
    id: data.id,
    isCrew: data.isCrew,
    isFerryCrossing: data.isFerryCrossing,
    isManualEntry: data.isManualEntry,
    isOutOfScope: data.isOutOfScope,
    isVehicleSource: data.isVehicleSource,
    isVehicleActive: data.isVehicleActive ?? true,
    registrationNumber: data.registrationNumber,
    vehicleId: data.vehicleId,
    vehicleType: data.vehicleType,
    slot: data.slot,
    type: data.type,
    duration: data.duration,
    originalStartTime: data.originalStartTime,
    originalEndTime: data.originalEndTime,
    isModifiedByUser: data.isModifiedByUser,
    modifiedBy: data.modifiedBy,
    modified: data.modified,
    source: data.source,
    driverTachographChartId: data.driverTachographChartId ?? null,
  }
}

const mapNote = (data: any): NoteModel => {
  return {
    date: data.date,
    dayType: getDayType(data.dayType),
    text: data.text,
  }
}

const mapPlace = (data: any): PlaceModel => {
  return {
    startTime: data.startTime,
    endTime: data.endTime,
    entryType: data.entryType ? PlaceEntryType.BEGIN : PlaceEntryType.END,
    nation: data.nation,
    nationCode: data.nationCode,
    odometerValue: data.odometerValue,
    isAutomaticBorder: data.isAutomaticBorder,
  }
}
const mapPartialBreak = (data: any): any => {
  return {
    breakTypeOrderIndex: data.breakTypeOrderIndex,
    firstPartRestEndTime: data.firstPartRestEndTime,
    secondPartBreakStartTime: data.secondPartBreakStartTime,
    formalRestEndDate: data.formalRestEndDate,
    formalRestDuration: data.formalRestDuration,
    restDuration: data.restDuration,
    realRestEndTime: data.realRestEndTime,
    id: data.id,
        startTime: data.startTime,
    endTime:data.endTime,
    // startTime: moment.utc(data.startTime).local(),
    // endTime: moment.utc(data.endTime).local(),
    duration: data.duration,
  }
}


const mapCardInsert = (data: any): CardInsertModel => {
  return {
    startTime: data.startTime,
    endTime: data.endTime,
    activityType: data.activity
      ? CardActivityType.INSERTED
      : CardActivityType.NOT_INSERTED,
  }
}

export const mapOutOfScope = (data: any): OutOfScopeModel => {
  return {
    startTime: moment.utc(data.startTime).local(),
    endTime: moment.utc(data.endTime).local(),
  }
}

export const mapExistingDelegation = (data: any): ExistingDelegationModel => {
  return {
    startTime: moment.utc(data.startTime).local(),
    endTime: moment.utc(data.endTime).local(),
    delegationId: data.delegationId,
    delegationNumber: data.delegationNumber,
    destinationCountryName: data.destinationCountryName,
  }
}

const mapTripEvent = (event: any): EventModel => {
  if (event == null) {
    return null
  }

  return {
    ...event,
    tripEvent: getEventType(event.tripEvent),
    vehicleType: getVehicleType(event.vehicleType),
    tmsRouteType: getTmsRouteType(event.tmsRouteType),
    date: moment(event.date),
    secondDate: event.secondDate != null ? moment(event.secondDate) : null,
  }
}

export const mapToActivityInfo = (payload: any): ActivityInfo => {
  return {
    activities:
      payload.activities && payload.activities.map((a) => mapActivity(a)),
    places: payload.places && payload.places.map((p) => mapPlace(p)),
    cardInserts:
      payload.cardInserts && payload.cardInserts.map((c) => mapCardInsert(c)),
    tripEvents:
      payload.tripEvents && payload.tripEvents.map((e) => mapTripEvent(e)),
    dayActivities: payload.dayActivities,
    violations: payload.violations,
    dailyRests: payload.dailyRests,
    dailyPartialRegularRests:
      payload.dailyPartialRegularRests ,
    weeklyRests: payload.weeklyRests,
    weeklyReducedRests: payload.weeklyReducedRests,
    notes: payload.notes && payload.notes.map((p) => mapNote(p)),
    breaks: payload.breaks,
    partialBreaks:
      payload.partialBreaks &&
      payload.partialBreaks.map((c) => mapPartialBreak(c)),
    weekRecompenses: payload.weekRecompenses,
    nightWorkActivities: payload.nightWorkActivities,
    outOfScopes:
      payload.outOfScopes && payload.outOfScopes.map((c) => mapOutOfScope(c)),
    existingDelegations:
      payload.existingDelegations &&
      payload.existingDelegations.map((c) => mapExistingDelegation(c)),
    vehicleEvents:
      payload.vehicleEvents &&
      payload.vehicleEvents.map((e) => ({
        type: e.type,
        beginTime: moment.utc(e.beginTime).local(),
        endTime: moment.utc(e.endTime).local(),
        registrationNumber: e.registrationNumber,
        driverCardNumber: e.driverCardNumber,
      })),
    vehicleSourceActivities:
      payload.vehicleSourceActivities &&
      payload.vehicleSourceActivities.map((a) => mapActivity(a)),
    driver: payload.driver,
    vehicle: payload.vehicle,
  }
}
